import EngagementAcceptedMenuButton from '@EngagementsActiveNumbers/ActiveNumbersEngagementAccepted/EngagementAcceptedMenuButton/EngagementAcceptedMenuButton';

export default EngagementAcceptedMenuButton;
